module.exports = __webpack_public_path__ + "static/media/6COPUOS3.c860401b.jpg";